import { useLoadingStore } from '@/modules/shared/stores/loadingStore'
import { axiosInstance } from '@/modules/shared/lib/axios'
const useGroupService = () => {
  const startLoading = useLoadingStore((s) => s.startLoading)
  const getGroups = async ({ companyId }: { companyId: string }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.get(`/api/${companyId}/driver/groups`)
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const addGroup = async ({
    companyId,
    name,
  }: {
    companyId: string
    name: string
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(
        `/api/${companyId}/driver/addGroup`,
        { name },
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const changeGroupName = async ({
    companyId,
    groupId,
    newName,
  }: {
    companyId: string
    groupId: number
    newName: string
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(
        `/api/${companyId}/driver/renameGroup`,
        {
          groupId: groupId,
          newName: newName,
        },
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const removeGroups = async ({
    companyId,
    groupIds,
  }: {
    companyId: string
    groupIds: number[]
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(
        `/api/${companyId}/driver/removeDriverGroups`,
        {
          groups: groupIds,
        },
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const addDriverToGroup = async ({
    companyId,
    groupId,
    driverIds,
  }: {
    companyId: string
    groupId: string
    driverIds: number[]
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(
        `/api/${companyId}/driver/addDriverToGroup`,
        { drivers: driverIds, groupId, companyId },
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const removeDriverFromGroup = async ({
    companyId,
    groupId,
    driverIds,
  }: {
    companyId: string
    groupId: string
    driverIds: number[]
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.post(
        `/api/${companyId}/driver/removeDriverFromGroup`,
        { drivers: driverIds, groupId, companyId },
      )
      return res.data
    } catch (err) {
      // Ograniczony do grup nie może zabrać kierowcy z ostatniej swojej grupy - komunikat pokazuje wołający.
      if ((err as { response?: { data?: { code?: string } } })?.response?.data?.code === 'DRIVER_GROUP_REQUIRED') throw err
      return []
    } finally {
      stopLoading()
    }
  }
  return {
    getGroups,
    addDriverToGroup,
    removeDriverFromGroup,
    addGroup,
    removeGroups,
    changeGroupName,
  }
}

export default useGroupService
